import { GridContainer, GridItem, GridRow } from "@tvg/fuse/grid";
import { LinkList as FuseLinkList } from "@tvg/fuse/link-list";
import { SpacingWrapper } from "@tvg/fuse/spacing-wrapper";
import React, { useMemo } from "react";
import { AmpLinkList } from "types/amplience";
import styles from "./LinkList.module.css";

export interface LinkListProps {
  config: AmpLinkList;
}

export const LinkList: React.FC<LinkListProps> = ({ config }) => {
  const populateLinks = useMemo(
    () =>
      config.links.map((link) => ({
        href: link.url,
        text: link.text,
      })),
    [config],
  );

  return (
    <SpacingWrapper marginBottom="l">
      <GridContainer className={styles.linkList}>
        <GridRow>
          <GridItem xxs={12} m={10} colStart-m={2} l={8} colStart-l={3}>
            <FuseLinkList links={populateLinks} dataTestId="content-link-list" />
          </GridItem>
        </GridRow>
      </GridContainer>
    </SpacingWrapper>
  );
};
